<template>
  <div
    class="video-player-wrap"
    :class="{
      'hidden-time-progress': isHiddenTimeProgress,
      'video-is-live': isLive,
      'show-retry': retryFlg > 0,
      'video-vol-display': this.defaultMuted
    }"
  >
    <vr-player v-on="$listeners" v-if="isVr && options" ref="videoPlayer" class="video-player" :options="playerOptions" @ready="vrReady"></vr-player>
    <player
      v-else-if="options"
      ref="videoPlayer"
      class="video-player vjs-custom-skin"
      :style="{ 'object-fit': 'fill' }"
      :playsinline="true"
      :options="playerOptions"
      :events="events"
      @canplay="onCanplay"
      @play="onPlay"
      @pause="onPause"
      @loadeddata="onLoadeddata"
      @timeupdate="onTimeupdate"
      @waiting="onWaiting"
      @playing="onPlaying"
      @ended="onEnded"
      @error="onError"
      @ready="playerReadied"
      @fullscreenchange="onPlayerFullScreenchange"
      @stalled="onStalled"
      v-bind="$attrs"
      v-on="$listeners"
    ></player>
    <div class="retry-layer" v-show="retryFlg" @click="retryPlay">
      <van-icon name="replay" />
    </div>
  </div>
</template>
<script>
require('video.js/dist/video-js.css');
require('./custom-theme.css');
import videojs from 'video.js';
import video_zhCN from 'video.js/dist/lang/zh-CN.json';
videojs.addLanguage('zh-CN', video_zhCN);
export default {
  name: 'VideoPlayer',
  inheritAttrs: false,
  props: {
    isVr: {
      type: Boolean,
      default: false
    },
    options: Object,
    registerDanmaku: {
      type: Boolean,
      default: false
    },
    registerClarity: {
      type: Boolean,
      default: false
    },

    clarityIconfont: {
      type: String,
      default: 'icon-yuanhua'
    },
    isHiddenTimeProgress: {
      type: Boolean,
      default: false
    },
    defaultMuted: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      events: ['fullscreenchange', 'waiting', 'stalled', 'error'],
      playerOptions: {
        // playbackRates: [0.5, 1.0, 1.25, 1.5, 2.0, 5.0], //播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: this.defaultMuted, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [],
        // flash: { hls: { withCredentials: false } }, // rtmp
        html5: {
          vhs: {
            withCredentials: false
            // enableLowInitialBitrate: true, // 网络不好时允许降低码率
            // enableWorker: true, // 使用Web Worker处理解析，提高性能
            // lowLatencyMode: true, // 直播模式下启用低延迟
            // liveSyncDurationCount: 6, // 直播同步时长数量
            // allowUpscaling: false // 不允许自动提升画质
            // maxBufferLength: 30, // 最大缓冲长度(秒)
            // maxBufferSize: 60 * 1024 * 1024, // 最大缓冲大小(60MB)
            // startLevel: -1, // 自动选择适合的码率级别
            // bandwidth: 1000000 // 初始带宽估计值
          }
        }, // m3u8
        poster: '',
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        // controls: true,
        controlBar: {
          liveDisplay: false,
          currentTimeDisplay: false,
          timeDivider: false,
          durationDisplay: false,
          remainingTimeDisplay: false, // 倒计时
          progressControl: true,
          fullscreenToggle: true //全屏按钮
        }
      },
      paused: true,
      isFull: false,
      percent: 0,
      waiting: true,
      bufferPercent: 0,
      currentText: '00:00',
      totalText: '00:00',
      isLive: true,
      localDanmaku: true,
      isRegisterDanmaku: false,
      clarityEl: null,
      retryFlg: false,
      waitingTimer: null, // 等待计时器
      autoRetryTimer: null, // 自动重试计时器
      retryCount: 0, // 重试次数
      maxRetryCount: 5, // 最大重试次数
      retryInterval: 3000 // 重试间隔（毫秒）
    };
  },
  computed: {
    player() {
      return this.$refs?.videoPlayer?.player;
    }
  },
  beforeDestroy() {
    // 组件销毁时清理所有计时器
    this.clearAllTimers();
  },

  watch: {
    clarityIconfont: {
      handler: function(value) {
        if (this.clarityEl) {
          this.clarityEl.className = this.clarityEl.className.replace(/iconfont icon-\w+/, 'iconfont ' + value);
        }
      },
      immediate: true
    },
    options: {
      handler(val) {
        if (!val) return;
        // app 默认的全屏按钮不要
        // if (this.isRmtEnv()) {
        //   this.playerOptions.controlBar.fullscreenToggle = false;
        // }

        if (val.sources && val.sources.length && (val.sources[0].src || '').indexOf('.m3u8') > -1) {
          this.isLive = true;
          if (window.$player && window.$player.muted && typeof window.$player.muted() === 'boolean') {
            this.playerOptions.muted = window.$player.muted();
          }
          this.playerOptions = Object.assign({}, this.playerOptions, this.options);
        } else {
          Object.assign(this.playerOptions.controlBar, {
            currentTimeDisplay: true,
            timeDivider: true,
            durationDisplay: true
          });
          this.playerOptions = Object.assign({}, this.playerOptions, this.options);

          this.isLive = false;
        }
        this.retryFlg = false;
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // start ============ 处理vr播放器 =============
    vrReady(vr) {
      this.registerClarity && this.addResolutionBtn(vr);
    },
    addResolutionBtn(vr) {
      const btn = document.createElement('div');
      btn.style =
        'position: inherit; right: 1rem; cursor: pointer; font-size: 1.5rem; line-height: 100%; color: #fff;padding: 0 8px;line-height: 2.2rem;';
      btn.className = `iconfont ${this.clarityIconfont}`;
      vr.toolBar.vrBtn.parentElement.replaceChild(btn, vr.toolBar.vrBtn);
      this.clarityEl = btn;
      btn.onclick = () => {
        this.onClarityToggle();
      };
    },
    // end ============ 处理vr播放器 =============
    isRmtEnv() {
      return window.navigator.userAgent.indexOf('Rmt') > -1;
    },
    onPlayerFullScreenchange() {
      if (this.player.paused()) {
        this.player.play();
      }
      // console.log('playerFullScreenchange')
      // window.screen.orientation.lock('landscape')
    },
    playerReadied() {
      console.log('playerReadied');

      this.registerClarity && this.createClarityButton();
      this.registerDanmaku && this.createBarrageButton();
      // fix
      if (this.options && this.options.autoplay === false) {
        return;
      }
      this.player.play();
      // app环境，添加自定义全屏按钮
      // if (this.isRmtEnv()) {
      //   this.createFullButton();
      // }
    },
    onCanplay() {
      console.log('onCanplay', this.player);
      this.waiting = false;

      // 清除等待计时器
      if (this.waitingTimer) {
        clearTimeout(this.waitingTimer);
        this.waitingTimer = null;
      }
      // this.player.play();
      // if (this.playerOptions.autoplay) {
      //   this.player.paused() && this.player.play();
      // }
    },
    createBarrageButton() {
      const _this = this;
      let Button = videojs.getComponent('Button');
      let barrageButton = videojs.extend(Button, {
        // constructor: function(player, options) {
        constructor: function() {
          Button.apply(this, arguments);
          // this.controlText('弹幕');
        },
        handleClick: function() {
          // 'icon-dopen' : 'icon-dstop';
          _this.localDanmaku = !_this.localDanmaku;
          _this.$emit('danmakuToggle', _this.localDanmaku);
          if (_this.localDanmaku) {
            this.el_.className = this.el_.className.replace('dstop', 'dopen');
          } else {
            this.el_.className = this.el_.className.replace('dopen', 'dstop');
          }
        },
        buildCSSClass: function() {
          return 'vjs-icon-custom-barragebutton vjs-control vjs-button iconfont icon-dopen';
        }
      });

      //注册
      videojs.registerComponent('barrageButton', barrageButton);

      this.$nextTick(() => {
        // 添加到controlBar中
        this.player.getChild('controlBar').addChild('barrageButton');
        // this.player.getChild('controlBar').addChild('barrageButton', {}, 3);
      });
      this.isRegisterDanmaku = true;
    },

    createClarityButton() {
      const _this = this;
      let Button = videojs.getComponent('Button');
      let clarityButton = videojs.extend(Button, {
        // constructor: function(player, options) {
        constructor: function() {
          Button.apply(this, arguments);
          _this.clarityEl = this.el_;
        },
        handleClick: function() {
          _this.onClarityToggle();
          _this.clarityEl = this.el_;
          // this.el_.className = this.el_.className.replace('dstop', 'dopen');
        },
        buildCSSClass: function() {
          console.log('clarityIconfont', _this.clarityIconfont);
          return `vjs-icon-custom-claritybutton vjs-control vjs-button iconfont ${_this.clarityIconfont}`;
        }
      });

      //注册
      videojs.registerComponent('clarityButton', clarityButton);

      this.$nextTick(() => {
        // 添加到controlBar中
        this.player.getChild('controlBar').addChild('clarityButton');
        // this.player.getChild('controlBar').addChild('barrageButton', {}, 3);
      });
    },

    createFullButton() {
      const _this = this;
      let Button = videojs.getComponent('Button');
      let fullButton = videojs.extend(Button, {
        constructor: function() {
          Button.apply(this, arguments);
        },
        handleClick: () => {
          _this.player.pause();
          // 绑定点击事件
          _this.openFullscreen();
          // console.log('time-----', _this.player.currentTime(), new String(this.player.currentTime() * 1000).toString());
        },
        buildCSSClass: function() {
          return 'vjs-icon-custom-fullscreenbutton vjs-control vjs-button iconfont icon-fullscreen';
        }
      });

      //注册
      videojs.registerComponent('fullButton', fullButton);

      this.$nextTick(() => {
        // 添加到controlBar中
        this.player.getChild('controlBar').addChild('fullButton');
      });
    },

    openFullscreen() {
      // console.log('open full player', this.playerOptions.sources[0].src);
      rmt?.openVideoPlayer({
        video: {
          sourceUrl: this.playerOptions.sources[0].src //视频地址
        },
        autoStart: true, //是否自动播放,
        timestamp: new String(this.player.currentTime() * 1000).toString() //开始时间戳：毫秒
      });
    },
    onClarityToggle() {
      this.$emit('clarityToggle', true);
    },
    initTimeLength(timeLength) {
      //根据秒数格式化时间
      timeLength = parseInt(timeLength);
      var second = timeLength % 60;
      var minute = (timeLength - second) / 60;
      return (minute < 10 ? '0' + minute : minute) + ':' + (second < 10 ? '0' + second : second);
    },
    onLoadeddata() {
      // this.totalText = this.initTimeLength(this.player.duration);
      // this.buffer();
    },
    onTimeupdate() {
      // 视频时长
      // const durationProgress = this.player.duration();
      // // currentTime 当前播放时长
      // const currentTimeProgress = this.player.currentTime();
      // // 将当前播放时长填入左边时长元素中
      // this.currentText = this.initTimeLength(this.player.currentTime());
      // // 求当前播放时长的进度，从而显示出来进度条
      // this.percent = 100 * (currentTimeProgress / durationProgress);
    },
    buffer() {
      //视频时长
      var maxduration = this.player.duration();
      //当前缓冲进度时长结束位置
      var currentBuffer = this.player.buffered().end(0);
      // 求取百分比
      this.bufferPercent = (100 * currentBuffer) / maxduration;
      if (currentBuffer < maxduration) {
        setTimeout(this.buffer, 500);
      }
    },
    playOrPause() {
      const b = this.player.paused();
      this.paused = !b;
      if (b) {
        this.player.play();
      } else {
        this.player.pause();
      }
    },
    onPlay() {
      this.paused = false;
      this.retryFlg = false;
    },
    onPause() {
      this.paused = true;
      this.waiting = false;
    },
    onWaiting() {
      // 标记为等待状态
      this.waiting = true;

      // 清除之前的等待计时器
      if (this.waitingTimer) {
        clearTimeout(this.waitingTimer);
      }

      // 设置新的等待超时检测（5秒后如果仍未恢复，则触发重试）
      this.waitingTimer = setTimeout(() => {
        if (this.waiting && this.isLive && !this.paused) {
          console.log('视频播放等待超时，尝试自动恢复...');
          this.autoRecoverPlayback();
        }
      }, 5000);
    },
    onPlaying() {
      // 播放恢复时重置等待状态和计时器
      this.waiting = false;
      this.retryCount = 0;
      if (this.waitingTimer) {
        clearTimeout(this.waitingTimer);
        this.waitingTimer = null;
      }
      if (this.autoRetryTimer) {
        clearTimeout(this.autoRetryTimer);
        this.autoRetryTimer = null;
      }
    },
    onEnded() {
      // console.log('ended', e);
    },
    onError() {
      console.log('onError', this.player?.error());
      this.player.errorDisplay.close();

      // 如果是直播状态且不是用户暂停，则触发自动重试
      if (this.isLive && !this.paused && this.retryCount < this.maxRetryCount) {
        this.scheduleAutoRetry();
      } else {
        this.retryFlg = true;
      }
    },
    retryPlay() {
      if (this.retryFlg) {
        this.retryFlg = false;
        this.manualRetry();
      }
    },

    // 手动重试
    manualRetry() {
      this.retryCount = 0;
      this.attemptRetry();
    },

    // 自动恢复播放（网络波动时）
    autoRecoverPlayback() {
      // 先尝试简单的恢复策略
      if (this.player && !this.player.paused()) {
        try {
          // 尝试暂停再播放
          this.player.pause();
          setTimeout(() => {
            this.player.play();
          }, 500);
        } catch (e) {
          console.error('恢复播放失败:', e);
          this.scheduleAutoRetry();
        }
      }
    },

    // 安排自动重试
    scheduleAutoRetry() {
      // 清除之前的重试计时器
      if (this.autoRetryTimer) {
        clearTimeout(this.autoRetryTimer);
      }

      // 如果未达到最大重试次数，则安排下一次重试
      if (this.retryCount < this.maxRetryCount) {
        this.autoRetryTimer = setTimeout(() => {
          this.attemptRetry();
        }, this.retryInterval);
      } else {
        // 达到最大重试次数，显示手动重试按钮
        this.retryFlg = true;
      }
    },

    // 尝试重试
    attemptRetry() {
      this.retryCount++;
      console.log(`自动重试播放 (${this.retryCount}/${this.maxRetryCount})`);

      try {
        if (this.$refs.videoPlayer && typeof this.$refs.videoPlayer.retry === 'function') {
          this.$refs.videoPlayer.retry();
        } else if (this.player) {
          // 如果没有retry方法，尝试重新加载视频源
          this.player.load();
          this.player.play();
        }
      } catch (e) {
        console.error('重试播放失败:', e);
        this.scheduleAutoRetry();
      }
    },

    // 清除所有计时器
    clearAllTimers() {
      if (this.waitingTimer) {
        clearTimeout(this.waitingTimer);
        this.waitingTimer = null;
      }
      if (this.autoRetryTimer) {
        clearTimeout(this.autoRetryTimer);
        this.autoRetryTimer = null;
      }
    },

    onStalled() {}
  }
};
</script>
<style lang="less" scoped>
.show-retry {
  /deep/.vjs-big-play-button {
    display: none;
  }
}
.video-is-live {
  /deep/ .video-js .vjs-custom-control-spacer.vjs-spacer {
    display: flex !important;
    flex: auto;
  }
}
.video-player-wrap {
  height: 100%;
  position: relative;
  &.video-vol-display {
    /deep/ .vjs-custom-skin > .video-js .vjs-control-bar .vjs-volume-panel {
      display: flex !important;
      margin-right: auto;
      // .vjs-volume-control {
      //   opacity: 1;
      // }
    }
    /deep/ .video-js .vjs-custom-control-spacer.vjs-spacer {
      display: flex !important;
      flex: auto;
    }
  }
}
</style>
<style lang="less">
.hidden-time-progress {
  .vjs-progress-control,
  .vjs-time-control {
    opacity: 0;
    pointer-events: none;
  }
}

.video-js {
  .vjs-control-bar {
    .vjs-icon-custom-barragebutton {
      font-size: 1.4em;
      line-height: 1.67;
      color: #fff;
      order: 6;
      width: 2em;
    }
    .vjs-icon-custom-claritybutton {
      font-size: 1.6em;
      line-height: 1.67;
      color: #fff;
      order: 6;
      width: 2em;
    }
    .vjs-icon-custom-fullscreenbutton {
      font-size: 1.4em;
      line-height: 1.67;
      color: #fff;
      order: 7;
      width: 2em;
    }
  }
}
</style>
